module.exports = __webpack_public_path__ + "static/media/image1.6eefcdb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/Restaurant/images/image1.jpg
// module id = 369
// module chunks = 0